import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import ChatApp from './pages/ChatApp';
import LoginPage from './pages/LoginPage';
import './App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/demo" element={<ChatApp />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/chat" element={<ChatApp />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
